import { render, staticRenderFns } from "./WhatsApp.vue?vue&type=template&id=9a680a4e&scoped=true&"
import script from "./WhatsApp.vue?vue&type=script&lang=js&"
export * from "./WhatsApp.vue?vue&type=script&lang=js&"
import style0 from "./WhatsApp.vue?vue&type=style&index=0&id=9a680a4e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a680a4e",
  null
  
)

export default component.exports